import { css, useTheme } from '@emotion/react';

const useStyle = () => {
  const theme = useTheme();
  const { background } = theme.palette;
  const { shadows } = theme;

  const qtyWrapper = css`
    display: flex;
    align-items: center;
  `;

  const qtyButton = css`
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: ${shadows[1]};
    border-radius: 16px;
    border: 2px solid ${background.gray3};
    background: white;
    padding: 0;
    margin: 0;
  `;

  const qtyValue = css`
    padding-inline: 7px;
    min-width: 24px;
    text-align: center;
    font-variant-numeric: tabular-nums;
  `;

  return { qtyWrapper, qtyButton, qtyValue };
};

export default useStyle;
